import './main.scss';
// TODO: Look into why this isn't working
// import 'grapesjs/dist/css/grapes.min.css';

import grapesjs from 'grapesjs';
import GRAPESJS_CONFIG from "./grapesjs-email-editor-plugin/configs/grapesjs.js";

async function initializeEditor() {
    await new Promise(resolve => PMW.initI18next(PMW.LANGUAGE, resolve));
    return grapesjs.init(GRAPESJS_CONFIG);
}

export default initializeEditor();
